/**
 * Mode the system is in
 */
export enum EMode {
    Live = "live",
    Testing = "testing"
}